import services from '../createServices';

export const workspace = {
  list: params => services.get('/workspace/list/current', { params }),
  currentWs: params => services.get('/workspace/current', { params }),
  switchCurrentWs: params => services.get('/workspace/switch', { params }),
  defaultWsList: params => services.get('/user/list/workspace', { params }),
  switchDefaultWs: params => services.get('/user/appoint/default', { params })
};
